import { fieldWithoutMarginStyles } from '@Guidelines/Theme/commonPassthrough';
import type { DocumentStatusFilter as DocumentStatusFilterValue } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/DocumentFilterView';
import documentFiltersSignal, {
	setDocumentFilters,
} from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentList/Filters/Signals/documentFiltersSignal';
import * as React from 'react';
import { useSignalValue } from '@verclam/pulsar';
import { Dropdown } from '@verclam/ui-kit';

type StatusOption = {
	readonly value: DocumentStatusFilterValue;
	readonly label: string;
};

const statusOptions: readonly StatusOption[] = [
	{ value: 'all', label: 'Tous les statuts' },
	{ value: 'toVerify', label: 'À vérifier' },
	{ value: 'verified', label: 'Vérifiés' },
];

/** Verification status preset written through to the signal immediately. */
const DocumentStatusFilter: React.FC = () => {
	const currentFilters = useSignalValue(documentFiltersSignal);

	const handleChange = React.useCallback((status: DocumentStatusFilterValue | null) => {
		if (status === null) {
			return;
		}

		setDocumentFilters(documentFiltersSignal.peek().setStatus(status));
	}, []);

	return (
		<Dropdown<DocumentStatusFilterValue>
			name="documentStatus"
			label="Statut"
			isLabelHidden
			options={[...statusOptions]}
			optionLabel="label"
			optionValue="value"
			value={currentFilters.status}
			onChange={handleChange}
			pt={fieldWithoutMarginStyles}
		/>
	);
};

export default DocumentStatusFilter;
